module.exports = __webpack_public_path__ + "c81fb3c1498e5b0cabf4700f1046a101.fbx";